import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Box,CircularProgress, Button,TextField,Divider } from '@mui/material';
import PartyInfoForTableRow from 'components/party/components/PartyInfoForTableRow';

import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import { partyApprovalMgmtAPI } from 'api/OmsOrdermgmtWebServices';
import { updatePartyObj } from 'store/slice/PharmaSlice';

export default function PartyMgmtAPI() {
    const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const dispatch = useDispatch();
    const [initiateRejection, setInitiateRejection] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [decision, setDecision] = useState(true);

    useEffect(() => {

    }, [partyObj]);

    const apiSuccess = (response)=>{
        setApiInProgress(false);
        dispatch(updatePartyObj(response.partyInfo))
        if (response.partyInfo.statusname==="REFERRED BACK")
            setSuccessMsg("Party '"+partyObj.title+"' is Rejected !!!");
        else
            setSuccessMsg("Party '"+partyObj.title+"' is Approved !!!");
    }
    const apiFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const handleApiSubmmission = (decision) =>{
        setDecision(decision);
        setErrMsg('')
        setApiInProgress(true);

        partyApprovalMgmtAPI({
            partyId:partyObj.id, rejectionReason:rejectionReason, approve:decision
        }, apiSuccess, apiFailure)
    }
    const getComponent = () =>{
        if (apiInProgress) return <CircularProgress/>
        if (successMsg!=='') return <Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>

        return <>
            <Grid item lg={4} xs={4} align="right" >
                <Button variant="contained" onClick={()=>handleApiSubmmission(true)}>Approve</Button>&nbsp;&nbsp;&nbsp;
                <Button variant="contained" onClick={()=>setInitiateRejection(true)}>Initiate Rejection</Button></Grid>
        </>
    }
    const handleTextChange = (e) => {
        setRejectionReason(e.target.value);
    }
    return (
        <>
            <Grid container direction="column" sx={{justifyContent: "flex-start",alignItems: "flex-start",padding:1}}>
                <Grid item lg={12} sx={{ width: '100%', backgroundColor: 'white',padding:1,  }}>
                    <Typography variant="h5">Party Info</Typography>
                </Grid>
                
                <Grid item lg={12} sx={{ width: '100%' }}>
                  <Box lg={12} sx={{ flexGrow: 1 }}>
                      <Grid item sx={{ padding:1, overflowY: "scroll", backgroundColor: 'white', maxHeight: '60vh' }}>
                          <PartyInfoForTableRow partyObj={ partyObj} />
                      </Grid>
                  </Box>
                </Grid>

                <Grid item lg={12} sx={{ width: '100%', padding:2}}>
                    <Divider/>
                </Grid>
                <Grid item lg={12} sx={{ width: '100%',backgroundColor:'white', }}>
                {initiateRejection?<>
                    <Grid container direction="row" sx={{padding:2,  justifyContent: "flex-end",alignItems: "center",  width: '100%'}} >
                        {apiInProgress?<CircularProgress/>:<>

                        {successMsg!==''?<Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>:<>
                        <Grid item lg={9} sx={{}}>
                                <TextField size="Normal"
                                    label="Rejection Reason"
                                    name="rejectionReason"
                                    value={rejectionReason}
                                    onChange={handleTextChange}
                                    rows={2}
                                    multiline
                                    //error={formValues.gst.error}
                                   // helperText={formValues.gst.error && formValues.gst.errorMessage}
                                    sx={{width:'100%'}}
                                />
                        </Grid>
                        <Grid item lg={3} align="right" >
                            <Button variant="contained" disabled={rejectionReason.length===0} onClick={()=>handleApiSubmmission(false)}>Reject</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="contained" onClick={()=>setInitiateRejection(false)}>Cancel Rejection</Button>
                        </Grid>
                        </>}
                        </>}
                    </Grid>
                </>:
                    <Grid container direction="row" sx={{justifyContent: "flex-end",alignItems: "center",  width: '100%'}} padding={1}>
                        <Grid item lg={8} xs={8} ><ErrorMessage  message={errMsg}/></Grid>
                            {getComponent()}
                    </Grid>
                }
                </Grid>
            </Grid>
        </>
    )
}